import { nameof } from "ts-simple-nameof";
import { DefaultCheckbox } from "../../../common/components/forms/inputs/checkbox/DefaultCheckbox";
import { ILoginFormModel } from "../models/loginFormModel";
import { ConsentPolicyType } from "../../../common/enums";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import styles from "./AuthenticateConsents.module.scss";

interface IAuthenticateConsentsProps {
  isTermsOfUseAvailable: boolean;
  onPolicyClick?: (poloicyType: ConsentPolicyType) => void;
}

export const AuthenticateConsents = ({
  isTermsOfUseAvailable,
  onPolicyClick,
}: IAuthenticateConsentsProps) => {
  const getLabel = (
    name: string,
    nonClickablePart: string,
    link: string,
    onClick: () => void,
  ) => {
    return (
      <span style={{ display: "inline" }}>
        <label htmlFor={name} style={{ cursor: "pointer" }}>{nonClickablePart} </label>
        <span onClick={(e) => { e.stopPropagation(); onClick(); }} className={styles.link}>
          {link}
        </span>
      </span>
    );
  };

  return (
    <div className={styles.wrapper}>
      <DefaultCheckbox
        name={nameof<ILoginFormModel>((x) => x.acceptPrivacyPolicy)}
        className={styles.checkbox}
        label={getLabel(
          nameof<ILoginFormModel>((x) => x.acceptPrivacyPolicy),
          "Съгласен съм с",
          "политиката за поверителност",
          () => onPolicyClick?.(ConsentPolicyType.PlannyPrivacyPolicy),
        )}
        type={"checkbox"}
        width="auto"
        required
      />

      <RenderWhen condition={isTermsOfUseAvailable}>
        <DefaultCheckbox
          name={nameof<ILoginFormModel>((x) => x.acceptTermsOfUse)}
          className={styles.checkbox}
          label={getLabel(
            nameof<ILoginFormModel>((x) => x.acceptTermsOfUse),
            "Съгласен съм с",
            "общите условия за ползване",
            () => onPolicyClick?.(ConsentPolicyType.TenantTermsOfUse),
          )}
          type={"checkbox"}
          width="auto"
          required
        />
      </RenderWhen>

      <DefaultCheckbox
        name={nameof<ILoginFormModel>((x) => x.acceptAutomatedEmails)}
        className={styles.checkbox}
        label={getLabel(
          nameof<ILoginFormModel>((x) => x.acceptAutomatedEmails),
          "Съгласен съм с",
          "политиката за автоматизирани имейли",
          () => onPolicyClick?.(ConsentPolicyType.AutomatedEmails),
        )}
        type={"checkbox"}
        width="auto"
        required
      />

      <DefaultCheckbox
        name={nameof<ILoginFormModel>((x) => x.acceptMarketingEmails)}
        className={styles.checkbox}
        label={getLabel(
          nameof<ILoginFormModel>((x) => x.acceptMarketingEmails),
          "Съгласен съм с",
          "политиката за маркетинг имейли",
          () => onPolicyClick?.(ConsentPolicyType.MarketingEmail),
        )}
        width="auto"
        type={"checkbox"}
      />
    </div>
  );
};
